// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3_aA6","alertIcon":"ConfirmModal_alertIcon__3knFZ"};